import React, { Component } from "react";
import { Link } from "react-router-dom";
import NxaFAQMessage from "../NxaFAQMessage";
import CTAButtons from "../ReuasbleComponets/CTAButtons";
class Message extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        {/* Main Banner  */}
        <section className="message-hero">
          <div className="message-image">
            <img
              className="message"
              src="./../assets/images/new_message_page/messagemain.webp"
              alt="Answering Messages"
              loading="lazy"
            />
          </div>
          <div className="message-content">
            <h1>
              Seamless Communication, <span>All in One </span>Place
            </h1>
            <p>
              Enhance customer engagement with NxaTel’s OmniChannel Messaging.
              Connect across WhatsApp, SMS, Chat, and Social Messengers in one
              powerful platform.
            </p>
            <div className="message-button">
              <CTAButtons />
            </div>
            <div className="log">
              <p>
                Already have an account?<a href="/login"> Log In now</a>
              </p>
            </div>
          </div>
        </section>
        {/* Key Features Section  */}
        <section className="key-features">
          <h1>
            Key <span>Features</span>
          </h1>
          <div className="connect-container">
            <div className="connect-image">
              <img
                className="connect"
                src="./../assets/images/new_message_page/multiplechannel.webp"
                alt="Answering Messages"
                loading="lazy"
              />
            </div>
            <div className="connect-content">
              <h2>Connect Across Multiple Channels</h2>
              <ul>
                <li>
                  WhatsApp, SMS, Web Chat, and Social Messengers integrated into
                  NxaTel.
                </li>
                <li>Streamline all conversations in one unified inbox.</li>
              </ul>
              <p>Team Inbox for Collaboration</p>
              <ul>
                <li>
                  Centralized inbox for teams to manage customer interactions
                  effortlessly.
                </li>
                <li>
                  Assign conversations to the right team member for faster
                  resolutions.
                </li>
              </ul>
              <p>Smart Assignments & Task Management</p>
              <ul>
                <li>
                  Assign messages to team members based on expertise and
                  availability.
                </li>
                <li>
                  Take notes, schedule tasks, and set callback Take notes,
                  schedule tasks, and set callback.
                </li>
              </ul>
              <div className="message-button">
                <CTAButtons />
              </div>
            </div>
          </div>
          <div className="omnichannel-container">
            <div className="omnichannel-content">
              <h2>Why Choose OmniChannel Messaging?</h2>

              <ul>
                <li>
                  <span>Gain a 360° Customer View </span>
                </li>
                <li>
                  Understand your customers’ journey by consolidating all
                  interactions across multiple channels.
                </li>
                <li>Engage Customers on Their Preferred Channel</li>
                <li>
                  Increase response rates by communicating through the channels
                  your customers use the most.
                </li>
                <li>Deliver a Unified Chat Experience</li>
                <li>
                  Manage conversations seamlessly with a single, easy-to-use
                  interface, ensuring consistent and personalized communication.
                </li>
              </ul>
              <div className="message-button">
                <CTAButtons />
              </div>
            </div>
            <div className="omnichannel-image">
              <img
                className="omnichannel"
                src="./../assets/images/new_message_page/omnichannel.webp"
                alt="Answering Messages"
                loading="lazy"
              />
            </div>
          </div>
        </section>

        {/* Powering Conversations */}
        <div className="backgroundwhite">
          <section className="power-conversations">
            <h1>Powering Conversations, Amplifying Engagement</h1>
            <p>Improve and unify your communications​</p>
            <div className="power-container">
              <div className="powercon-content">
                <ul>
                  <li>
                    WhatsApp, SMS, Web Chat & Social Messenger Integration
                  </li>
                  <li>Team Inbox for Shared Communication</li>
                  <li>Assign Conversations to Team Members</li>
                  <li>Task & Callback Scheduling</li>
                  <li>Customer Interaction History & Notes</li>
                  <li>Unified Messaging Portal for Seamless Engagement</li>
                </ul>
              </div>
              <div className="powercon-image">
                <img
                  className="power"
                  src="./../assets/images/new_message_page/Nxatel-whatapp-GIF.gif"
                  alt="Answering Messages Gif"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="Power-ctas">
              <a
                href="/signup"
                className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--16-0 "
              >
                Try for free
              </a>
              <div className="power-schedule">
                <a href="/signup">
                  Try it Schedule your first meeting ​​
                  <img
                    src="./../assets/images/new_message_page/event.svg"
                    alt="meeting"
                  />
                </a>
              </div>
            </div>
          </section>
        </div>
        {/* Built for Teams */}
        <div className="work-together">
          <div className="work-together__container">
            <h2 className="work-together__title">Built for your teams</h2>
            <p className="work-together__subtitle">
              Stay connected and productive with everything in one place—no
              <br /> more juggling multiple apps.
            </p>

            <div className="work-together__cards">
              {/* Card 1 */}
              <div className="work-together__card">
                <div className="work-together__card-header">
                  SMS and Chat made simple on the Go
                </div>
                <div className="work-together__card-image">
                  <img
                    src="./../assets/images/new_message_page/mobile.webp"
                    alt="Mobile App"
                    loading="lazy"
                    width={200}
                  />
                </div>
                <Link to="/signup" className="work-together__card-link">
                  <span className="work-together__card-link-text">
                    Download and
                    <br /> Try for Free
                  </span>
                  <img
                    src="./../assets/images/right-arrow-dwn.svg"
                    alt="Right Arrow"
                    className="work-together__card-link-icon"
                  />
                </Link>
              </div>

              {/* Card 2 */}
              <div className="work-together__card">
                <div className="work-together__card-header">
                  Connect to customers via WhatsApp Inbox
                </div>
                <div className="work-together__card-image">
                  <img
                    src="./../assets/images/new_message_page/messagelaptop.webp"
                    alt="Laptop"
                    loading="lazy"
                    width={280}
                  />
                </div>
                <Link to="/demo" className="work-together__card-link">
                  <span className="work-together__card-link-text">
                    Get your Demo
                    <br /> See Nxatel in action
                  </span>
                  <img
                    src="./../assets/images/right-arrow-dwn.svg"
                    alt="Right Arrow"
                    loading="lazy"
                    className="work-together__card-link-icon"
                  />
                </Link>
              </div>

              {/* Card 3 */}
              <div className="work-together__card">
                <div className="work-together__card-header">
                  <br />
                  Mobile Devices
                </div>
                <div className="work-together__card-image">
                  <img
                    src="./../assets/images/new_message_page/device.webp"
                    alt="Device"
                    loading="lazy"
                    width={270}
                  />
                </div>
                <Link to="#" className="work-together__card-link">
                  <span className="work-together__card-link-text">
                    Explore our Devices
                  </span>
                  <img
                    src="./../assets/images/right-arrow-dwn.svg"
                    alt="Right Arrow"
                    loading="lazy"
                    className="work-together__card-link-icon"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* NxaTel Faq */}
        <NxaFAQMessage />
        {/* NxaTel Try for free */}
        <section className="message-start-free">
          <div className="message-start-image">
            <img
              className="message-free"
              src="./../assets/images/new_message_page/guytryfree.webp"
              alt="Lady Taking a Call"
              loading="lazy"
            />
          </div>
          <div className="message-start-free__content">
            <h1>Start Engaging Customers Today – Sign Up Now!</h1>
            <p>
              Transform the way you engage with customers. Sign up now and take
              your customer communication to the next level!
            </p>
            <div className="message-button">
              <CTAButtons />
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Message;
